import sanitizeSingle from './single';
import sanitizeMultiple from './multiple';

export default (showResponse) => ({
  singles: (showResponse.singles || []).map(sanitizeSingle),
  multiples: (showResponse.multiples || []).map(sanitizeMultiple),
  removeStakeForBonusBet: showResponse.removeStakeForBonusBet,
  betslipReference: showResponse.betslipReference,
});
